import { observer } from 'mobx-react';
import { TabPanel, TabView } from 'primereact/tabview';
import DrugContent from './components/drugTabContent/DrugTabContent';
import ConceptTabHeader from './components/header/ConceptTabHeader';
import classes from './conceptSelector.module.scss';
import { useConceptSelector } from './useConceptSelector';
import DrugTabContentSkeleton from './components/drugTabSkeleton/DrugTabSkeletonLoader';

const ConceptSelector = () => {
  const {
    currentTabIndex,
    isConceptsListLoading,
    drugConceptsList,
    handleTabChange,
  } = useConceptSelector();
  return (
    <div className={classes.conceptsContainer}>
      <div className={classes.conceptsContainerHeader}>Concept</div>
      <div className={classes.conceptTabs}>
        {!isConceptsListLoading ? (
          <TabView scrollable tabIndex={currentTabIndex} onTabChange={handleTabChange}>
            {drugConceptsList.map((drug, index) => {
              return (
                <TabPanel
                  className={classes.tabInstance}
                  key={index}
                  header={
                    <ConceptTabHeader
                      drugDetails={drug}
                      isSelected={currentTabIndex === index}
                      tabIndex={index}
                    />
                  }
                >
                  <DrugContent />
                </TabPanel>
              );
            })}
          </TabView>
        ) : (
          <DrugTabContentSkeleton />
        )}
      </div>
    </div>
  );
};
export default observer(ConceptSelector);
